export default __webpack_public_path__ + "3f91e2068af027e87f27bdce2511698d.png";